import React, { Component } from "react";

const TrialEnd = (props: any) => {
    return <h4>Obrigado pelo seu contato. Entraremos em contato em breve</h4>;
};

export default TrialEnd;
